import type { FC } from "react";
import { Link } from "react-router-dom";

type MatchingConditionAlertProps = {
  show: boolean;
};

/**
 * マッチング条件未設定時の警告アラート
 * @param {MatchingConditionAlertProps} props - コンポーネントProps
 * @return {JSX.Element | null} 警告アラートまたは null
 */
export const MatchingConditionAlert: FC<MatchingConditionAlertProps> = ({
  show,
}) => {
  if (!show) return null;

  return (
    <div className="alert alert-warning mb-4 py-3">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="stroke-current shrink-0 h-5 w-5"
        fill="none"
        viewBox="0 0 24 24"
        role="img"
        aria-label="警告"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
        />
      </svg>
      <span>
        アクティブなマッチング設定がありません。マッチング精度を向上させるには、
        <Link
          to="/settings/matching/conditions"
          className="link link-primary font-semibold"
        >
          マッチング条件設定
        </Link>
        を登録・アクティブ化してください。
      </span>
    </div>
  );
};
